function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5C10.5 9.18629 10.5 11.8137 10.5 16.5",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5L4.5 10.5",
    stroke: "#809790",
    style: {
      stroke: "#809790",
      stroke: "color(display-p3 0.5020 0.5922 0.5647)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayAddIcon);
export default __webpack_public_path__ + "static/media/grayAddIcon.99e3d5bf2f0a5b2860709d4d27c24315.svg";
export { ForwardRef as ReactComponent };